import React from 'react'
import CoreMovedAlert from "v4/components/admin/CoreMovedAlert/CoreMovedAlert";

export default function TemplatesPage() {
    return <CoreMovedAlert corePath="admin/templates"/>
}
